import React from 'react';
import { isFunction } from 'lodash';

import {
  FormLabel,
  Select,
  SelectItem,
  Spacer,
  Text,
} from '@zapier/design-system';

export type DropdownField = {
  /** Additional content to describe this field. */
  details?: React.ReactNode;
  /** The unique ID of this field. */
  id: string;
  /** Is this field required? */
  isRequired?: boolean;
  /** The label that describes this field. */
  label: string;
  /** Identifies this field type. */
  type: 'dropdown';
  /** Items to display in the dropdown. */
  items: {
    label: string;
    value: string;
  }[];
};

export type DropdownProps = {
  /** The callback function to fire when the field changes. */
  onChange: (value: string) => void;
  /** Static properties about this field. */
  staticProperties: DropdownField;
  /** A prefilled value from some higher state. */
  value?: string;
};

/**
 * A dropdown form field.
 */
const Dropdown = ({
  onChange,
  staticProperties: { details, id, items, isRequired, label },
  value,
}: DropdownProps) => {
  return (
    <div>
      <FormLabel htmlFor={id} isRequired={isRequired}>
        {label}
      </FormLabel>
      {!details && <Spacer height={5} />}
      {details && (
        <Text margin="10px 0">{isFunction(details) ? details() : details}</Text>
      )}
      <Select
        label={label}
        isLabelHidden
        isRequired={isRequired}
        id={id}
        defaultSelectedKey={value ?? null}
        onChange={key => onChange(key as string)}
      >
        {items.map(item => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
};

export default Dropdown;
